import type { FinancialProduct, ItemList, WithContext } from 'schema-dts';

const buildFinancialProductItemListSchema = (
  financialProducts: Array<WithContext<FinancialProduct>>,
): WithContext<ItemList> => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: financialProducts.map((financialProduct, index) => {
    const { '@context': _ignoredContext, ...item } = financialProduct;

    return {
      '@type': 'ListItem',
      item,
      position: index + 1,
    };
  }),
  numberOfItems: financialProducts.length,
});

export default buildFinancialProductItemListSchema;
